import {API} from '../../Services';


async function RootData(merchantId){
    return API.get(`/shop/${merchantId}/product_category/?parent__isnull=true&is_primary=true`);
}

async function SlugData(slug){
    return API.get(`/merchants/slug/${slug}`);
}

async function CouponData(id){
    return API.get(`/coupons/code/${id}/public`);
}

async function CatsData(merchantId,parentId){
    return API.get(`/shop/${merchantId}/product_category_public/?parent__uid=${parentId}`);
}

async function ProductData(merchantId,catId){
    return API.get(`/shop/${merchantId}/product-public/?category__uid=${catId}&page_size=200`);
}
async function AllMenuData(merchantId){
    let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/products_menu/`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

async function ProductDetailData(merchantId,productId){
    let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/product/${productId}`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}




export {CatsData,ProductData,RootData,AllMenuData,ProductDetailData,SlugData,CouponData};
